import React from 'react';
import { FormattedMessage } from 'react-intl';
import toTitleCase from '../utils/to-title-case';

export const TitleFormattedMessage = (props: any) => {
  return (
    <FormattedMessage
      {...props}
      children={(val) => {
        // Ensure val is a string before passing to toTitleCase
        const stringVal = typeof val === 'string' ? val : String(val || '');
        return toTitleCase(stringVal);
      }}
    />
  );
};
